import axios from 'axios';
import {BACKEND_URL} from '../constants/ServiceUrl'

export default {
    get(){
        return axios.get(BACKEND_URL+'Announcement/getHomePosts.php');
    },
    getAll () {
        return axios.get(BACKEND_URL+'Announcement/get.php');
    },
    add (data) {
        return axios.post(BACKEND_URL+'Announcement/add.php', data);
    },
    delete(data){
        return axios.post(BACKEND_URL+'Announcement/delete.php', data);
    },
    save(data){
        return axios.put(BACKEND_URL+'Announcement/update.php', data);
    }
}


// WEBPACK FOOTER //
// ./src/api/AnnouncementApi.js